'use strict'
/**
 * 应用常量配置文件
 *
 */
const constants = {
  // 静态资源 URL
  STATIC_URL: 'http://static.cainiaolipin.cn/',
}

module.exports = constants



//////////////////
// WEBPACK FOOTER
// ./config/constants.js
// module id = aurM
// module chunks = 2